import { render, staticRenderFns } from "./AdditionalFeatures.vue?vue&type=template&id=31af005b&scoped=true&"
import script from "./AdditionalFeatures.vue?vue&type=script&lang=js&"
export * from "./AdditionalFeatures.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalFeatures.vue?vue&type=style&index=0&id=31af005b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31af005b",
  null
  
)

export default component.exports